<template>

	<div style="background:#fff;padding: 20px;margin-bottom: 8px;border-radius: 10px;">
		<div class="flex justify-between align-center toptitle">
			<div class="topleft">已获政策支持</div>
			<div class="topright">申请补贴总金额：<span class="rione">{{supporttotal_money ? supporttotal_money : 0}}万元</span>
			</div>
		</div>
		<div>
			<div class="box5 box2_cc">
				<div class="box5_text1  text-center  text-bold" style="width: 40px;">序号</div>
				<div class="box5_text2 justify-center justify-center  text-bold">政策类别</div>
				<div class="box5_text2 text-bold justify-center">政府补贴项目名称</div>
				<div class="box5_text2 text-bold justify-center">课题名称</div>
				<div class="box5_text2 text-bold justify-center width-80" style="flex:none;">
					年份
				</div>
				<div class="box5_text2 text-bold justify-center" style="min-width: 250px;">
					补贴金额（万元）
				</div>
				<!-- <div class="box5_text2 ">服务机构</div> -->
			</div>
			<div v-if="newlist">
				<div v-for="(item, index) in newlist" :key="index" class="box5">
					<div class="box5_text1 text-center text-center" style="width: 40px;">
						<div class="response text-center">{{ index+1 }}</div>
					</div>
					<div class="box5_text2 justify-center text-center">
						{{ item.dynamic ? item.dynamic : "--" }}
					</div>
					<div class="box5_text2 cpoint justify-center text-center" @click="toout(item.name_href)"
						style="color: #0070c0;">
						{{ item.entry_name ? item.entry_name : '--' }}
					</div>
					<div class="box5_text2 justify-center text-center">
						{{ item.topic_name ? item.topic_name : '--' }}
					</div>
					<div class="box5_text2 justify-center  width-80" style="flex:none;">
						{{ item.year ? item.year : '--' }}
					</div>
					<div v-if="!item.showz" class="box5_text2 justify-center"
						style="min-width: 250px;justify-content: space-around;text-align: center;">
						<div class="cpoint" @click="toout(item.province_support_href)"
							style="margin: 8px 10px;width: 50%;">省：<span
								style="color: #0070c0;">{{item.province_support ? item.province_support : '--'}}</span>
						</div>
						<div class="cpoint" @click="toout(item.city_support_href)" style="margin: 8px 10px;width: 50%;">
							市：<span style="color: #0070c0;">{{item.city_support ? item.city_support : '--'}}</span>
						</div>
						<div class="cpoint" @click="toout(item.area_support_href)" style="margin: 8px 10px;width: 50%;">
							区：<span style="color: #0070c0;">{{item.area_support ? item.area_support : '--'}}</span>
						</div>
					</div>
					<div v-if="item.showz" class="box5_text2 text-center"
						style="min-width: 250px;justify-content: center;text-align: left;">
						<div>见政策详情</div>
					</div>
					<!-- <div class="box5_text2 text-center cpoint" @click="toout(item.href)" style="color: #0070c0;">
						{{ item.service ? item.service : '--' }}
					</div> -->
				</div>
				<div class="padding-bottom-40" v-if="!newlist.length">
					<nomore></nomore>
				</div>
			</div>
			<div class="padding-bottom-40" v-else>
				<nomore></nomore>
			</div>
		</div>

		<div  class="text-right" style="padding: 10px 0">
			<el-pagination background :page-size="pagesize" :page-sizes="pageSizes" :hide-on-single-page="false"
				layout="prev, pager, next,sizes" @size-change="handleSizeChange"
				@current-change="handleCurrentChange($event,0)" :current-page="currentPage" :total="totalnum">
			</el-pagination>
		</div>
	</div>

</template>

<script>
	export default {
		props: {
			id: {
				type: [String, Number],
				default: ""
			}
		},
		data() {
			return {
				newlist: [],
				token: "",
				totalnum: 0,
				currentPage: 1,
				pagesize: 10,
				type: 0,
				supporttotal_money: '',
				pageSizes: [10, 20, 30, 40, 50],
			}
		},
		methods: {
			getnewlist() {
				this.$https.post({
						api: this.$api.api.newapi.enterprise_support,
						type: "formData",
					}, {
						start: this.currentPage,
						page_size: this.token ? this.pagesize : 5,
						id: this.id
					},
					(response) => {
						console.log("response", response);
						response.data.policy_support.forEach(item => {
							item['showz'] = false;
							// !item.support &&
							if (!item.province_support && !item.city_support && !item.area_support) {
								item['showz'] = true;
							}
						});
						this.supporttotal_money = response.data.total_money;
						this.newlist = response.data.policy_support;
						this.totalnum = response.count;
					},
					(error) => {
						// console.log(error);
					}
				);
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getnewlist();
			},
			handleSizeChange(size) {
				this.pagesize = size
				this.currentPage = 1;
				this.getnewlist();
			},
			toout(href) {
				// console.log(href)
				if (!href) {
					return false;
				}
				window.open(href)
			},
		},
		created() {
			// this.token = localStorage.getItem('userid') ? localStorage.getItem('userid') : '';
			this.getnewlist()
		}
	}
</script>

<style lang="scss" scoped>
	@import '../detailcss.scss';

	.box5_text2 {
		border-right: 1px solid #f1f1f1;
	}

	.box5_text1 {
		border-right: 1px solid #f1f1f1;
		border-left: 1px solid #f1f1f1;
	}

	.box2_cc {
		.box5_text2 {
			border-right: none;
		}

		.box5_text1 {
			border-right: none;
			border-left: none;
		}
	}
</style>



// WEBPACK FOOTER //
// policy-page.vue?29f771f5